
const {parse} = require('../html')
const navLayout = require('./visualiser_nav_item.html')

const Visualiser = class {
    constructor(name, analysis, options={}) {
        this.name = name
        this.api = analysis.api
        this.document = analysis.document
        this.config = analysis.config
        this.summary = analysis.summary
        this.options = options

        this.content = null
        this.ondata = () => {}
    }
    dom() {
        return document.createElement('div')
    }
    nav() {
        return parse(navLayout, {name: this.name}).querySelector('#content')
    }
    update() {
    }
    data(data) {
    }
    word(word) {
        
    }
}

module.exports = Visualiser
